import { theme } from "./utils/theming"

export const sectionHeaderDefaults = {
  paddingTop: 36,
  paddingRight: 36,
  paddingBottom: 0,
  paddingLeft: 36,
  backgroundColor: "#ffffff"
}

export const sectionBodyDefaults = {
  marginBottom: 36,
  paddingTop: 36,
  paddingRight: 36,
  paddingBottom: 36,
  paddingLeft: 36,
  backgroundColor: "#ffffff"
}

export const sectionDefaults = {
  backgroundColor: null,
  backgroundImage: null,
  backgroundOpacity: 1,
  marginTop: 0,
  marginRight: "auto",
  marginBottom: 0,
  marginLeft: "auto",
  paddingTop: 0,
  paddingRight: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  borderColor: "#f0f0f0",
  borderTopRightRadius: 0,
  borderTopLeftRadius: 0,
  borderBottomRightRadius: 0,
  borderBottomLeftRadius: 0,
  borderTopWidth: 0,
  borderLeftWidth: 0,
  borderRightWidth: 0,
  borderBottomWidth: 0,
  maxWidth: 640,
  contentWidth: 640,
  theme: theme()
}
